import React, { createContext, ReactNode, useContext, useState } from 'react'
import { addressState } from './redux/deviceStatistics/types'
import { defaultGatewayLoaction } from './utils/helper'

interface SessionContexProps {
  openModal: boolean
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>
  reCall?: boolean
  setReCall?: React.Dispatch<React.SetStateAction<boolean>> | any
  serviceApi?: boolean
  setServiceApi?: React.Dispatch<React.SetStateAction<boolean>> | any
  cellularUsageReCall?: boolean
  setCellularUsageReCall?: React.Dispatch<React.SetStateAction<boolean>> | any
  groupDetailsReCall?: boolean
  setGroupDetailsReCall?: React.Dispatch<React.SetStateAction<boolean>> | any
  userDetailsReCall?: boolean
  setUserDetailsReCall?: React.Dispatch<React.SetStateAction<boolean>> | any
  csReCall?: boolean
  setCSReCall?: React.Dispatch<React.SetStateAction<boolean>> | any
  fullLoading?: boolean
  setFullLoading?: React.Dispatch<React.SetStateAction<boolean>> | any
  collapsed?: boolean
  setCollapsed?: React.Dispatch<React.SetStateAction<boolean>> | any
  isMinimized?: boolean
  setIsMinimized?: React.Dispatch<React.SetStateAction<boolean>> | any
  setActiveName?: React.Dispatch<React.SetStateAction<string>> | any
  activeName?: string
  setGoogleAddressOpenModal?: React.Dispatch<React.SetStateAction<boolean>>
  googleAddressOpenModal?: boolean
  markerPosition: { lat: number; lng: number }
  setMarkerPosition: React.Dispatch<React.SetStateAction<{ lat: number; lng: number }>>
  setAddressState: React.Dispatch<React.SetStateAction<addressState>>
  addressState: addressState
  setSearchSelected: React.Dispatch<React.SetStateAction<boolean>>
  searchSelected: boolean
  setIsMarkerDrag: React.Dispatch<React.SetStateAction<boolean>>
  isMarkerDrag: boolean
  setNotificationListReCall: React.Dispatch<React.SetStateAction<boolean>>
  notificationListReCall: boolean
  setAddMSOModalOpen: React.Dispatch<React.SetStateAction<boolean>>
  addMSOModalOpen: boolean
}

const SessionContex = createContext<SessionContexProps | undefined>(undefined)

export const SessionContexProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [openModal, setOpenModal] = useState<boolean>(false)
  const [googleAddressOpenModal, setGoogleAddressOpenModal] = useState<boolean>(false)
  const [reCall, setReCall] = useState<boolean>(false)
  const [groupDetailsReCall, setGroupDetailsReCall] = useState<boolean>(false)
  const [userDetailsReCall, setUserDetailsReCall] = useState<boolean>(false)
  const [cellularUsageReCall, setCellularUsageReCall] = useState<boolean>(false)
  const [csReCall, setCSReCall] = useState<boolean>(false)
  const [fullLoading, setFullLoading] = useState<boolean>(false)
  const [collapsed, setCollapsed] = useState(true)
  const [isMinimized, setIsMinimized] = useState(false)
  const [serviceApi, setServiceApi] = useState<boolean>(localStorage.getItem('isPCverified') === 'true' ? true : false)
  const [activeName, setActiveName] = useState('Overview')
  const [markerPosition, setMarkerPosition] = useState(defaultGatewayLoaction)
  const [addressState, setAddressState] = useState<addressState>({
    flatNumber: '',
    landmark: '',
    area: '',
    city: '',
    state: '',
    country: '',
    zipcode: ''
  })
  const [searchSelected, setSearchSelected] = useState(false)
  const [isMarkerDrag, setIsMarkerDrag] = useState(false)
  const [notificationListReCall, setNotificationListReCall] = useState(false)
  const [addMSOModalOpen, setAddMSOModalOpen] = useState(false)

  return (
    <SessionContex.Provider
      value={{
        openModal,
        setOpenModal,
        reCall,
        setReCall,
        serviceApi,
        setServiceApi,
        cellularUsageReCall,
        setGroupDetailsReCall,
        setCellularUsageReCall,
        groupDetailsReCall,
        userDetailsReCall,
        setUserDetailsReCall,
        csReCall,
        setCSReCall,
        setFullLoading,
        fullLoading,
        setCollapsed,
        collapsed,
        setIsMinimized,
        isMinimized,
        setActiveName,
        activeName,
        setGoogleAddressOpenModal,
        googleAddressOpenModal,
        setMarkerPosition,
        markerPosition,
        setAddressState,
        addressState,
        setSearchSelected,
        searchSelected,
        setIsMarkerDrag,
        isMarkerDrag,
        setNotificationListReCall,
        notificationListReCall,
        setAddMSOModalOpen,
        addMSOModalOpen
      }}
    >
      {children}
    </SessionContex.Provider>
  )
}

export const useSessionContex = (): SessionContexProps => {
  const context = useContext(SessionContex)
  if (!context) {
    throw new Error('SessionContex must be used within an SessionContexProvider')
  }
  return context
}
